import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import { ActionPlansContext } from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageList from "@mui/material/ImageList";
import { makeStyles } from "@mui/styles";
import UserService from "services/UserService";
import { getActionTURPE } from "services/ConfigServices";
import RTMetersPowers from "./RTMetersPowers";
import SubmitButton from "components/CustomButtons/SubmitButton";
import {
  calculateTurpeEco,
  optimizePsous,
} from "utilities/fonctionsturpe.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function SelectMetersDialog(props) {
  const { closeModal, setLoading, refetch } = props;

  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;
  const actionContext = useContext(ActionContext);
  const { action, setAction } = actionContext;
  const [actionId, setActionId] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [selectedMeters, setSelectedMeters] = useState(
    action.parameters?.impact?.meters
  );

  const handleSelectedChange = ({ selectedRows }) => {
    selectedRows.map((meter) => (meter.isSelected = true));
    setSelectedMeters(selectedRows);
  };

  const handleSubmit = async () => {
    editListMeters();
    closeModal();
    //refetch();
  };

  const editListMeters = async () => {
    let meters = action.parameters?.impact?.meters || [];
    let metersIds = meters.map((meter) => meter.uuid);
    let newMeters = selectedMeters.filter(
      (obj) => !metersIds.includes(obj.uuid)
    );
    if (newMeters.length) {
      let data = [];

      let newMetersIds = newMeters.map((meter) => meter.uuid);
      await axios
        .post(
          getActionTURPE(action?.parameters?.general?.groups),
          { metersIds: newMetersIds },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          data = res.data.meters;
        });

      data.map((meter) => {
        meter.details.margin = action.parameters?.impact?.metersMargin;
        optimizePsous(meter.details);
        calculateTurpeEco(meter.details, action.parameters?.impact?.recFTAEnabled || false);
      });
      let allSelectedMeters = [
        ...selectedMeters.filter((obj) => metersIds.includes(obj.uuid)),
        ...data,
      ];

      allSelectedMeters.map((meter) => (meter.isSelected = true));
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.parameters?.impact,
            meters: allSelectedMeters,
          },
        },
      }));
    } else {
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.parameters?.impact,
            meters: selectedMeters,
          },
        },
      }));
    }
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <RTMetersPowers
            selectedMeters={selectedMeters}
            handleSelectedChange={handleSelectedChange}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <div style={{ display: "flex", flexDirection: "flex-end" }}>
            <SubmitButton
              //buttonDisabled={buttonDisabled}
              handleSubmit={handleSubmit}
            >
              Valider la sélection
            </SubmitButton>
          </div>
        </GridItem>
      </GridContainer>
    </>
  );
}

export default SelectMetersDialog;
